import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "contents-sub-title-text" };
const _hoisted_2 = { class: "contents-sub-title-text brg-color-grey-800" };
const _hoisted_3 = {
    key: 2,
    class: "text-red"
};
const _hoisted_4 = { key: 3 };
const _hoisted_5 = { class: "caption-normal-text brg-color-grey-700" };
const _hoisted_6 = {
    key: 0,
    class: "input-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BarogoTooltip = _resolveComponent("BarogoTooltip");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_row = _resolveComponent("v-row");
    return (_openBlock(), _createBlock(_component_v_row, {
        "no-gutters": "",
        class: _normalizeClass(_ctx.inputRowClass)
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_col, {
                cols: _ctx.inputRowTitleColRange,
                class: _normalizeClass([_ctx.inputRowTitleClass, "input-row-label"])
            }, {
                default: _withCtx(() => [
                    _createCommentVNode(" 툴팁 케이스 "),
                    (_ctx.showTooltip)
                        ? (_openBlock(), _createBlock(_component_BarogoTooltip, {
                            key: 0,
                            right: ""
                        }, {
                            activatorSlot: _withCtx(() => [
                                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1 /* TEXT */)
                            ]),
                            tooltipMessage: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.tooltipText), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode(" 툴팁 없는 케이스 "),
                            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1 /* TEXT */)
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                    (_ctx.isRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 서브텍스트 https://www.figma.com/file/MC48vUUguBidnS5y7rZFnb/%5BHCR%5D-Design-System_Vuetify?type=design&node-id=127-4156&mode=design&t=oYl7NFrv8BbIqQdo-4 "),
                    (_ctx.showInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.infoText), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["cols", "class"]),
            _createVNode(_component_v_col, {
                cols: _ctx.inputRowInputColRange,
                class: _normalizeClass(_ctx.inputRowContentClass)
            }, {
                default: _withCtx(() => [
                    _createCommentVNode(" 높이 보정을 위한 상단 여백 추가 "),
                    (_ctx.isNormalTextState)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _renderSlot(_ctx.$slots, "default")
                        ]))
                        : _renderSlot(_ctx.$slots, "default", { key: 1 })
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["cols", "class"])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["class"]));
}
